import React from 'react';
import { ApplicationsIcon, ArchiveIcon, ColumnLayoutIcon, DashboardIcon, DatabaseIcon, DiagramTreeIcon, ManualIcon, PaneProps } from 'evergreen-ui';
import { DATA, DEVICES, FORMS, MESSAGES, MONITOR, OBSERVATIONS, PROFILE } from 'Features/routePaths';
import { LinkIconsWithTooltip, NavLinkButtons } from 'Shared/LinkButtons';
import { getStationDatasourcePath, isHydropad } from './utils';
import { hasMonitorForDatasourceTypeByName } from '../Datasource/Monitors/monitorByType';

// note: наследуем от PaneProps, так как обе обертки для кнопок наследуют от них
type IconControlsProps = PaneProps & {
  stationId: number,
  datasourceId: number,
  /** короткое имя типа источника */
  datasourceName?: string,
  /**
   * `true` - кнопки с названиями справа от иконки,
   * `false` - кнопки-иконки с подсказками
   * @default false
  */
  isExpanded?: boolean,
}

/** Элементы навигации для источника станции */
export function DatasourceIconControls({
  stationId, datasourceId, datasourceName = '', isExpanded = false, ...paneProps
}: IconControlsProps) {
  const toStationDatasourcePath = stationId ? `${getStationDatasourcePath({ stationId, datasourceId })}/` : undefined;

  const { notHydropadType, notMonitor } = React.useMemo(() => {
    return {
      notHydropadType: !isHydropad(datasourceName),
      notMonitor: !hasMonitorForDatasourceTypeByName(datasourceName),
    };
  }, [datasourceName]);

  const iconControls = React.useMemo(() => {
    return [
      {
        to: OBSERVATIONS,
        name: 'Наблюдения',
        icon: ManualIcon,
        isInvisible: notHydropadType,
      },
      {
        to: MONITOR,
        name: 'Монитор',
        icon: DashboardIcon,
        isInvisible: notMonitor,
      },
      {
        to: FORMS,
        name: 'Формы',
        icon: ColumnLayoutIcon,
        isInvisible: notHydropadType,
      },
      {
        to: DEVICES,
        name: 'Датчики',
        icon: DiagramTreeIcon,
        isInvisible: !notHydropadType,
      },
      {
        to: PROFILE,
        name: 'Профиль',
        icon: ApplicationsIcon,
      },
      {
        to: MESSAGES,
        name: 'Сообщения',
        icon: ArchiveIcon,
      },
      {
        to: DATA,
        name: 'Данные',
        icon: DatabaseIcon,
      },
    ];
  }, [notHydropadType, notMonitor]);

  if (isExpanded) {
    return (
      <NavLinkButtons
        buttons={iconControls}
        pathPrefix={toStationDatasourcePath}
        {...paneProps}
      />
    );
  }
  return (
    <LinkIconsWithTooltip
      buttons={iconControls}
      pathPrefix={toStationDatasourcePath}
      {...paneProps}
    />
  );
}
export const MemoDatasourceIconControls = React.memo(DatasourceIconControls);
MemoDatasourceIconControls.displayName = 'MemoDatasourceIconControls';
export default DatasourceIconControls;
